var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRosPostcard = function SvgRosPostcard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 34"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M38.483 32.706H5.302A3.3 3.3 0 0 1 2 29.404V5.302A3.3 3.3 0 0 1 5.302 2h33.181a3.3 3.3 0 0 1 3.302 3.302v24.102a3.3 3.3 0 0 1-3.302 3.302M21.975 7.448v19.81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M31.34 13.39h4.546a.947.947 0 0 0 .946-.946V7.899a.947.947 0 0 0-.947-.947h-4.544a.947.947 0 0 0-.947.947v4.545c0 .523.424.947.947.947M6.953 10.254h4.292M6.953 15.207h10.07M6.953 20.16h10.07M6.953 25.112h10.07"
  })));
};
export default SvgRosPostcard;